import React from 'react';
import Reveal from 'react-reveal';
const AppGetstarted =()=>{
    return(
        <section className="get_started_area_white justify-content-center">
            <div className="shap one"></div>
            <div className="shap two"></div>
            <div className="shap one three"></div>
            <div className="shap two four"></div>
            <div className="container align-content-center">
                <div className="row align-items-center">
                    <div className="col-lg-1"></div>
                    <div className="col-lg-6 d-flex align-items-center">
                        <Reveal bottom cascade>
                            <div className="get_content">
                                <h2 className="f_700 f_p f_size_40 l_height50 mb_20 wow fadeInLeft hemdahl-text-dark" data-wow-delay="0.3s">Download the Hemdahl Food Safety App</h2>
                                <p className="f_400 f_p mb_40 wow fadeInLeft" data-wow-delay="0.4s">The Hemdahl Food Safety app is a great companion tool for Food Safety Professionals. It provides access to our database of recommended storage parameters for food products in your pocket.</p>
                                <a href="https://play.google.com/store/apps/details?id=com.hemdahl.foodappv2" className="app_btn app_btn_one wow fadeInLeft" data-wow-delay="0.5s"><img src={require('../img/home7/google_icon.png')} alt=""/>Google Play</a>
                                <a href="https://itunes.apple.com/us/app/hemdahl-food-safety-guide/id1068562710?mt=8" className="app_btn app_btn_one wow fadeInLeftx" data-wow-delay="0.5s"><img src={require('../img/apple-sml.png')} alt=""/>App Store</a>
                            </div>
                        </Reveal>
                    </div>
                    <div className="col-lg-4 text-right ms-5 mt-5">
                       <Reveal effect="fadeInRight" duration={2200}><img width={'50%'} src={require('../img/hemdahl-app-screenshot-nobg.png')} alt=""/></Reveal>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default AppGetstarted;